// API Configuration
export const API_BASE_URL = process.env.REACT_APP_GETWAY_API + "dif-auction/api/v1" || 'http://localhost:8626/dif-auction/api/v1';
